import { lazy, memo, Suspense } from "react";

import { Box } from "@seneca/senekit";
import { AnyQuestionI } from "@seneca/short-answer-service-types";

import { isTextQuestion } from "services/shortAnswerService/question-types/typeGuards";

import loaderWithRetry from "seneca-common/utils/loaderWithRetry";

import EQQuestionMarkdownRenderer from "./ExamQuestionMarkdown/EQQuestionMarkdownRenderer";
import styles from "./ExamQuestionTitle.module.scss";

const MAX_POSSIBLE_TITLE_WIDTH = "1280px";

export const ExamQuestionTitle = memo(ExamQuestionTitleImpl);

const EQCalculationTitle = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "eq-calculation-title-chunk" */
        "./EQCalculationTitle"
      )
  )
);

function ExamQuestionTitleImpl({ question }: { question: AnyQuestionI }) {
  return (
    <Box className={styles.titleWrapper}>
      <Box position="absolute" minWidth={MAX_POSSIBLE_TITLE_WIDTH}>
        <TitleComponent question={question} />
      </Box>
    </Box>
  );
}

function TitleComponent({ question }: { question: AnyQuestionI }) {
  if (isTextQuestion(question)) {
    return (
      <EQQuestionMarkdownRenderer
        markdown={getFirstLine(question.questionTextMd)}
        disableTooltips
      />
    );
  }

  return (
    <Suspense>
      <EQCalculationTitle question={question} />;
    </Suspense>
  );
}

function getFirstLine(text: string) {
  return (
    text
      .split(/<br>|\n/)
      .find(it => it.trim().length > 0)
      ?.replace(/^>+/, "") || ""
  );
}
